module.exports = __webpack_public_path__ + "static/media/22_shape_r.2bb867e6.webp";